import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

//UI

import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

//Hook

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'
import { useCallback } from 'react'
import useUser from '@/features/users/useUser'

const UserListHeader = ({ handleAddCustomer }) => {
  //Hooks

  const dispatch = useDispatch()
  const { useFetchAllUsers, useUploadUsers } = useUser()
  const uploadUsers = useUploadUsers()

  const { data: allUserResponse } = useFetchAllUsers({
    page: 1,
    pageSize: 0,
    sortBy: 'fullName',
    orderBy: 1,
  }) // Page Size 0 means get all

  const handleUpload = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    try {
      dispatch(showLoadingOverlay())
      await uploadUsers.mutateAsync(file)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownload = useCallback(() => {
    if (!allUserResponse?.data) {
      return
    }
    try {
      const excelData = allUserResponse?.data.map((row) => ({
        email: row.email,
        employeeNumber: row.employeeNumber,
        firstName: row.firstName,
        lastName: row.lastName,
        contactNumber: row.contactNumber ?? '',
        initial: row.initial,
        title: row.title,
        role: row.role,
        businessUnitName: row.businessUnit,
        contributorGroup: row.contributorGroup,
        departmentCodes: row.teamCodes ? row.teamCodes.join(',') : '',
        defaultDepartmentCode: row.defaultTeamCode,
        technicalLineManagerEmail: row?.technicalLineManagerEmail || '',
        commercialLineManagerEmail: row?.commercialLineManagerEmail || '',
        costCenterCode: row?.costCenter,
        division: row?.division ?? '',
        adminRoles: row.adminRoles ? row.adminRoles.join(',') : '',
        status: row.status,
      }))

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'user.xlsx')
    } catch (err) {
      console.log(err)
    }
  }, [allUserResponse?.data])

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>Users</Heading>

        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownload}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>

        <Spacer />
        <Link to="/admin/users/create">
          <Button colorScheme="blue">Create User</Button>
        </Link>
      </Flex>
    </>
  )
}

export default UserListHeader
